var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('segment-elem',{staticClass:"overlay-segment",class:{
    'is-visible': _vm.isVisible,
    'is-overlay-slider': _vm.isOverlaySlider
  },nativeOn:{"click":function($event){return _vm.clickHandler()}}})}
var staticRenderFns = []

export { render, staticRenderFns }